import React from 'react';
import { Phone, Mail, MapPin, Clock, MessageCircle } from 'lucide-react';
import { psychologistInfo } from '../data/mock';
import AppointmentContactForm from '../components/AppointmentContactForm';

const AppointmentPage = () => {
  return (
    <div>
      {/* Page Header */}
      <section className="bg-teal-700 py-16 md:py-20">
        <div className="container mx-auto px-6">
          <div className="text-center text-white">
            <p className="text-sand-200 font-medium tracking-[0.3em] uppercase text-xs mb-2">Запись</p>
            <h1 className="text-4xl md:text-5xl font-serif">Запишитесь на консультацию</h1>
            <p className="mt-4 text-sand-100 max-w-2xl mx-auto">
              Оставьте заявку, и я свяжусь с вами в ближайшее время
            </p>
          </div>
        </div>
      </section>

      {/* Appointment Form */}
      <section className="py-16 md:py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid gap-10 lg:grid-cols-2 lg:gap-16">
            {/* Contact Info */}
            <div className="space-y-8">
              <div>
                <h2 className="text-3xl font-serif text-stone-800 mb-4">
                  Контактная информация
                </h2>
                <p className="text-stone-600">
                  Вы можете связаться со мной любым удобным способом
                </p>
              </div>

              <div className="space-y-4">
                <a href={`tel:${psychologistInfo.phone}`} className="flex items-center gap-4 bg-sand-100 rounded-xl p-5 hover:bg-teal-50 transition-colors group">
                  <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center group-hover:bg-teal-600 transition-colors">
                    <Phone className="text-teal-600 group-hover:text-white transition-colors" size={24} />
                  </div>
                  <div>
                    <p className="text-stone-500 text-sm">Телефон</p>
                    <p className="text-stone-800 font-semibold text-lg">{psychologistInfo.phone}</p>
                  </div>
                </a>

                <a href={`mailto:${psychologistInfo.email}`} className="flex items-center gap-4 bg-sand-100 rounded-xl p-5 hover:bg-teal-50 transition-colors group">
                  <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center group-hover:bg-teal-600 transition-colors">
                    <Mail className="text-teal-600 group-hover:text-white transition-colors" size={24} />
                  </div>
                  <div>
                    <p className="text-stone-500 text-sm">Email</p>
                    <p className="text-stone-800 font-semibold text-lg">{psychologistInfo.email}</p>
                  </div>
                </a>

                <div className="flex items-center gap-4 bg-sand-100 rounded-xl p-5">
                  <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center">
                    <MapPin className="text-teal-600" size={24} />
                  </div>
                  <div>
                    <p className="text-stone-500 text-sm">Адрес</p>
                    <p className="text-stone-800 font-semibold">{psychologistInfo.address}</p>
                  </div>
                </div>

                <div className="flex items-center gap-4 bg-sand-100 rounded-xl p-5">
                  <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center">
                    <Clock className="text-teal-600" size={24} />
                  </div>
                  <div>
                    <p className="text-stone-500 text-sm">Часы работы</p>
                    <p className="text-stone-800 font-semibold">
                      Ежедневно: {psychologistInfo.workingHours.weekdays}
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex gap-3">
                <a href={psychologistInfo.social.telegram} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-sky-500 text-white px-5 py-3 rounded-lg hover:bg-sky-600 transition-colors">
                  <MessageCircle size={20} />
                  <span className="font-medium">Telegram</span>
                </a>
                <a href={psychologistInfo.social.whatsapp} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-green-500 text-white px-5 py-3 rounded-lg hover:bg-green-600 transition-colors">
                  <MessageCircle size={20} />
                  <span className="font-medium">WhatsApp</span>
                </a>
              </div>
            </div>

            {/* Form */}
            <AppointmentContactForm idPrefix="appointment-page" />
          </div>
        </div>
      </section>
    </div>
  );
};

export default AppointmentPage;
